function initialSocket() {
  return {
    someoneIsTyping: false,
    someoneTypedTime: null,
    messages: [],
  };
}

export {initialSocket};
